<template>
    <div class="soldout">
        <div class="soldout__inner-border">
            <p class="soldout__text">{{ label }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            label: { type: String, default: '' },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/mixins';

    .soldout {
        z-index: $layer--dropdown;
        height: inherit;
        text-align: center;
        border: 14px solid $color--bg-input;
        border-radius: 10%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(-15deg);

        @include breakpoint(tablet) {
            border: 10px solid $color--bg-input;
        }

        &__inner-border {
            margin: 10px 10px;
            border: 7px solid $color--bg-input;
            border-radius: 10%;
            @include breakpoint(tablet) {
                margin: 6px 6px;
                border: 3px solid $color--bg-input;
            }
        }
        &__text {
            font-size: 60px;
            margin: 10px 10px;
            color: $color--bg-input;
            font-weight: 800;
            @include breakpoint(smartphone-large) {
                font-size: 40px;
                font-weight: 600;
            }
            @include breakpoint(smartphone-large) {
                font-size: 24px;
                font-weight: 600;
            }
        }
    }

    .subdomain-layout {
        &--navy_black,
        &--black {
            .soldout {
                border-color: $subdomain-almost-black3;
                &__inner-border {
                    border-color: $subdomain-almost-black3;
                }
                &__text {
                    color: $subdomain-almost-black3;
                }
            }
        }
    }
</style>
